// extracted by mini-css-extract-plugin
module.exports = {"tab":"NavigationTabs_tab__jKfGx","tabGroupActive":"NavigationTabs_tabGroupActive__WNRCG"};